let configuration: Configuration

class Configuration {
  CLIENT_TYPE: string = 'OWA'
  LEGACY_SOCKET_GROUP_ID: string = '00000000-0000-0000-0000-000000000000'
  DIALOG_SOCKET_GROUP_ID: string = '00000000-0000-0000-0000-000000000001'
  TRACKING_ID_PROPERTY_NAME: string = 'emailGuid'
  REPLY_TRACKING_ID_PROPERTY_NAME: string = 'replyTrackingId'
  CI_HANDLED_PROPERTY_NAME: string = 'CIHandled'
  SENT_ITEMS_PENDING_QUEUE_KEY: string = 'sentItemsPendingQueue'
  LAST_PROCESSED_SENT_DATETIME_KEY: string = 'lastProcessedSentDateTime'
  APPEND_ON_SEND_MANIFEST_VERSION: string = '2022.1.13'
  EMAIL_BLAST_SENDER_ADDRESS: string = 'no-reply@cirrusinsight.com'
  EMAIL_BLAST_ID_TAG: string = 'EmailBlastId:'
  IGNORE_GRAPH_LOGIN_FLAG = 'IgnoreGraphLoginRequest'
  SUPPORTED_REQUIREMENT_SETS: string[] = []

  NODE_ENV: string = process.env.NODE_ENV!
  GRAPH_CLIENT_ID: string = process.env.GRAPH_CLIENT_ID!
  MANIFEST_APP_ID: string = process.env.MANIFEST_APP_ID!
  LOG_ENV: string = process.env.LOG_ENV!
  CIRRUS_CRM_API_BASEURL: string = process.env.CIRRUS_CRM_API_BASEURL!
  CIRRUS_API_BASEURL: string = process.env.CIRRUS_API_BASEURL!
  CIRRUS_REWRITE_BASEURL: string = process.env.CIRRUS_REWRITE_BASEURL!
  CIRRUS_TRACKING_BASEURL: string = process.env.CIRRUS_TRACKING_BASEURL!
  CIRRUS_PORTAL: string = this.getPartnerUrl(process.env.CIRRUS_PORTAL!)
  LOGGING_API_BASEURL: string = process.env.LOGGING_API_BASEURL!

  getPartnerUrl(defaultUrl) {
    const urlParams = new URLSearchParams(window.location.search)
    const partnerHost = urlParams.get('partnerDomain')

    if (partnerHost) {
      return 'https://' + partnerHost
    } else {
      return defaultUrl
    }
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default configuration = new Configuration()
